import { render, staticRenderFns } from "./RespuestaVer.vue?vue&type=template&id=ff0d0a16&scoped=true&"
import script from "./RespuestaVer.vue?vue&type=script&lang=js&"
export * from "./RespuestaVer.vue?vue&type=script&lang=js&"
import style0 from "./RespuestaVer.vue?vue&type=style&index=0&id=ff0d0a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0d0a16",
  null
  
)

export default component.exports